import { Button, Modal, Text } from '@querodelivery/uni-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTriangleExclamation,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import styles from './cancel-mission-modal.module.scss';

export interface CancelMissionModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const CancelMissionModal = ({
  isOpen,
  isLoading = false,
  onConfirm,
  onClose,
}: CancelMissionModalProps) => {
  const handleClose = isLoading ? () => undefined : onClose;

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      width="31.25rem"
      showCloseIcon={false}
      className={styles.modalShell}
      contentClassName={styles.modalContent}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          <button
            type="button"
            className={styles.closeButton}
            onClick={handleClose}
            aria-label="Fechar modal"
            disabled={isLoading}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <FontAwesomeIcon icon={faTriangleExclamation} className={styles.icon} />

        <div className={styles.body}>
          <div className={styles.text}>
            <Text
              as="h2"
              fontSize="md"
              fontWeight="bold"
              lineHeight="sm"
              tone="base"
            >
              Você está cancelando uma missão agendada.
            </Text>
            <Text
              as="p"
              fontSize="sm"
              fontWeight="medium"
              lineHeight="lg"
              tone="secondary"
            >
              Você está cancelando uma missão, certeza que deseja continuar?
            </Text>
          </div>

          <div className={styles.actions}>
            <Button
              type="button"
              size="lg"
              onClick={onConfirm}
              loading={isLoading}
              disabled={isLoading}
            >
              sim, cancelar
            </Button>
            <Button
              type="button"
              size="lg"
              variant="outline"
              onClick={handleClose}
              disabled={isLoading}
            >
              voltar
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
